import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
// import reportWebVitals from "./reportWebVitals";
import serviceWorker from './serviceWorker';
import AppConfigWrapper from './saas/AppConfigWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppConfigWrapper>
    <App />
  </AppConfigWrapper>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
serviceWorker();
